import React, { useEffect, useState } from "react";
import * as informationAPI from "../../apis/information";
import { StyledVideoItem, StyledVideoListContainer } from "./Video.styles";
import { toStringByFormatting } from "../../utils/dateFormatter";
import { FlexRowCenterContainer } from "../common/Container";
import Pagination from "react-js-pagination";
import { useParams } from "react-router-dom";
import { useInput } from "../../utils/useInput";
import { StyledInformationListUpperContainer } from "./Information.styles";
import { useTranslation } from "react-i18next";

const VideoItem = ({ authorName, createdDate, id, thumbnail, title, video, index }) => {
  const params = useParams();

  const [videoVisible, setVideoVisible] = useState(false);
  const [youtubeThumbnail, setYoutubeThumbnail] = useState(thumbnail);

  useEffect(() => {
    if (params.id) {
      if (params.id == id) {
        setVideoVisible(true);
      }
    }

    const regex = /embed\/([a-zA-Z0-9_-]{11})/;
    const match = video.match(regex);
    const getYoutubeId = match ? match[1] : "";
    setYoutubeThumbnail(`https://i.ytimg.com/vi/${getYoutubeId}/0.jpg`);
  }, [id, params.id, video]);

  return (
    <>
      {videoVisible && (
        <div
          className="video-modal"
          onClick={(e) => {
            e.preventDefault();
            setVideoVisible(false);
            document.body.style.overflow = "unset";
          }}
        >
          <div className="video">
            <iframe src={video} title={title} />
            <img
              src="/img/close.svg"
              alt="close"
              className="close"
              onClick={(e) => {
                e.preventDefault();
                setVideoVisible(false);
                document.body.style.overflow = "unset";
              }}
            />
          </div>
        </div>
      )}
      <StyledVideoItem
        index={index}
        onClick={(e) => {
          e.preventDefault();
          setVideoVisible(!videoVisible);
          document.body.style.overflow = "hidden";
        }}
      >
        <div className="thumb-hover">
          <img src="/img/search.svg" alt="search" />
        </div>
        <img src={youtubeThumbnail} alt="video-thumbnail" className="thumbnail" />
        <div className="video-info">
          <p className="title">{title}</p>
          <div className="tirivials">
            <p className="author">{authorName}</p>
            <div className="divider" />
            <p className="date">{toStringByFormatting(new Date(createdDate))}</p>
          </div>
        </div>
      </StyledVideoItem>
    </>
  );
};

export default function VideoList() {
  const { t, i18n } = useTranslation();

  const orderings = [
    { label: t("newest"), name: "-createdDate" },
    { label: t("popular"), name: "recommendCount" },
    { label: t("look-up"), name: "-viewsCount" },
    { label: t("update-time"), name: "-updatedDate" },
  ];

  const keywords = [
    { label: t("all"), name: "searchAll" },
    { label: t("title"), name: "searchTitle" },
    { label: t("writer"), name: "searchAuthorName" },
  ];

  const [videos, setVideos] = useState([]);
  const [current, setCurrent] = useState(
    Number(localStorage.getItem("success-case-page")) &&
      Number(localStorage.getItem("success-case-page")) > 0
      ? Number(localStorage.getItem("success-case-page"))
      : 1,
  );
  const [total, setTotal] = useState(0);
  const [showSearchSortDropdown, setShowSearchSortDropdown] = useState(false);
  const [searchSort, setSearchSort] = useState(orderings[0]);
  const [showSearchKeywordDropdown, setShowSearchKeywordDropdown] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState(keywords[0]);
  const [keyword, setKeyword] = useInput("");

  const onChangePage = (page) => {
    localStorage.setItem("video-page", page);
    setCurrent(page);
  };

  useEffect(() => {
    setSearchSort(orderings[0]);
    setSearchKeyword(keywords[0]);
  }, [i18n.language]);

  useEffect(() => {
    localStorage.setItem("video-page", 1);
  }, []);

  useEffect(() => {
    informationAPI
      .getVideos({ page: current, pageSize: 9, ordering: searchSort.name })
      .then((res) => {
        if (res.data.linusCode === 1) {
          setTotal(res.data.page.count);
          setVideos(res.data.data);
        }
      });
  }, []);

  useEffect(() => {
    informationAPI
      .getVideos({ page: current, pageSize: 9, ordering: searchSort.name })
      .then((res) => {
        if (res.data.linusCode === 1) {
          setTotal(res.data.page.count);
          setVideos(res.data.data);
        }
      });
  }, [current, searchSort.name]);

  const onSearch = (e) => {
    e.preventDefault();

    if (!keyword || keyword.trim().length === 0) {
      alert("검색어를 입력해주세요.");
      return;
    }

    const request = { page: current, pageSize: 9, ordering: searchSort.name };
    request[searchKeyword.name] = keyword;
    informationAPI.getVideos(request).then((res) => {
      if (res.data.linusCode === 1) {
        setTotal(res.data.page.count);
        setVideos(res.data.data);
      }
    });
  };

  return (
    <StyledVideoListContainer>
      <StyledInformationListUpperContainer
        showSearchSortDropdown={showSearchSortDropdown}
        showSearchKeywordDropdown={showSearchKeywordDropdown}
      >
        <div className="bottom-container">
          <div className="total-count">
            {t("all")} <span>{total}</span>
          </div>
          <div className="search-sort-container-mobile">
            <div
              className="search-sort"
              onClick={() => {
                setShowSearchSortDropdown(!showSearchSortDropdown);
              }}
            >
              <p>{searchSort.label}</p>
              <div className="search-sort-button">
                <img src="/img/arrow-down.svg" alt="arrow-down" />
              </div>
            </div>
            <div className="search-sort-dropdown">
              {orderings.map((i) => (
                <p
                  key={i.name}
                  onClick={() => {
                    setSearchSort(i);
                    setShowSearchSortDropdown(false);
                  }}
                >
                  {i.label}
                </p>
              ))}
            </div>
          </div>
        </div>
        <div className="search-container">
          <div className="search-sort-container">
            <div
              className="search-sort"
              onClick={() => {
                setShowSearchSortDropdown(!showSearchSortDropdown);
              }}
            >
              <p>{searchSort.label}</p>
              <div className="search-sort-button">
                <img src="/img/arrow-down.svg" alt="arrow-down" />
              </div>
            </div>
            <div className="search-sort-dropdown">
              {orderings.map((i) => (
                <p
                  key={i.name}
                  onClick={() => {
                    setSearchSort(i);
                    setShowSearchSortDropdown(false);
                  }}
                >
                  {i.label}
                </p>
              ))}
            </div>
          </div>
          <div className="search-form">
            <div className="search-keyword-type-container">
              <div
                className="search-keyword-type"
                onClick={() => {
                  setShowSearchKeywordDropdown(!showSearchKeywordDropdown);
                }}
              >
                <p>{searchKeyword.label}</p>
                <div className="search-sort-button">
                  <img src="/img/arrow-down.svg" alt="arrow-down" />
                </div>
              </div>
              <div className="search-keyword-type-dropdown">
                {keywords.map((i) => (
                  <p
                    key={i.name}
                    onClick={() => {
                      setSearchKeyword(i);
                      setShowSearchKeywordDropdown(false);
                    }}
                  >
                    {i.label}
                  </p>
                ))}
              </div>
            </div>
            <form className="form" onSubmit={onSearch}>
              <input className="search-input" type={"text"} onChange={setKeyword} />
              <button type="submit">
                <img src="/img/search@3x.png" alt="search" />
              </button>
            </form>
          </div>
        </div>
      </StyledInformationListUpperContainer>
      <div className="blocks">
        {videos.map((i, idx) => (
          <VideoItem key={i.id} index={idx} {...i} />
        ))}
      </div>
      <FlexRowCenterContainer style={{ width: "100%" }}>
        <Pagination
          activePage={current}
          itemsCountPerPage={9}
          totalItemsCount={total}
          pageRangeDisplayed={window.innerWidth <= 768 ? 5 : 10}
          onChange={onChangePage}
          firstPageText={<img src="/img/first.svg" alt="first" />}
          lastPageText={<img src="/img/icon-page-last.svg" alt="last" />}
          prevPageText={<img src="/img/prev.svg" alt="prev" />}
          nextPageText={<img src="/img/next.svg" alt="next" />}
          itemClass="pagination-item"
          itemClassFirst="pagination-first"
          itemClassPrev="pagination-prev"
          itemClassNext="pagination-next"
          itemClassLast="pagination-last"
          activeClass="pagination-active"
          activeLinkClass="pagination-active-link"
          linkClass="pagination-link"
          linkClassFirst="pagination-link-first"
          linkClassPrev="pagination-link-prev"
          linkClassNext="pagination-link-next"
          linkClassLast="pagination-link-last"
        />
      </FlexRowCenterContainer>
    </StyledVideoListContainer>
  );
}
